document.addEventListener('DOMContentLoaded', () => {
    popupModifyInscriptionExtras();
});

const parseExtrasString = (str) =>
    String(str || '')
        .split(';')
        .map(v => v.trim())
        .filter(Boolean);

const fetchAvailableExtras = async ({
                                        ajaxUrl,
                                        inscriptionID = '',
                                        activityID = '',
                                        inscriptionType = '',
                                        nonce = ''
                                    }) => {
    const fd = new FormData();
    fd.append('action', 'get_activity_extras_for_update');

    if (inscriptionID) fd.append('inscription_id', inscriptionID);
    if (activityID) fd.append('activity_id', activityID);
    if (nonce) fd.append('nonce', nonce);

    fd.append('inscription_type', inscriptionType);

    const res = await fetch(ajaxUrl, { method: 'POST', body: fd });
    const raw = await res.text();

    try {
        const json = JSON.parse(raw);

        if (json && json.success) {
            const payload =
                (typeof json.data === 'string')
                    ? json.data
                    : (json.data?.extras || json.data?.message || '');
            return parseExtrasString(payload);
        }

        const payload = (typeof json?.data === 'string') ? json.data : '';
        return parseExtrasString(payload);
    } catch (_) {
        return parseExtrasString(raw);
    }
};

const popupModifyInscriptionExtras = () => {
    const popup     = document.getElementById('popup-modify-extras');
    const openBtns  = document.querySelectorAll('[id^="open-popup-modify-extras-"]');
    const closeBtn  = document.getElementById('close-popup-modify-extras');
    const container = document.getElementById('extras-container-popup');

    if (!popup || !closeBtn || !container || !openBtns || !openBtns.length) return;

    const ajaxUrl = (typeof popupExtras !== 'undefined' && popupExtras.ajax_url)
        ? popupExtras.ajax_url
        : '/wp-admin/admin-ajax.php';

    const openPopup = () => {
        popup.style.display = '';          // quita display:none
        popup.classList.add('is-active');  // por si tienes estilos por clase
    };

    const closePopup = () => {
        popup.classList.remove('is-active');
        popup.style.display = 'none'; // vuelve a ocultar
        container.innerHTML = '';
    };

    openBtns.forEach((openBtn) => {
        openBtn.addEventListener('click', async (e) => {
            openPopup();

            const inscriptionID     = e.currentTarget.dataset.id || '';
            const inscriptionType   = e.currentTarget.dataset.tipoincripcion || '';
            const activityID        = e.currentTarget.dataset.idactividad || '';
            const extrasContratados = e.currentTarget.dataset.extracontrata || '';
            const nonce             = (typeof popupExtras !== 'undefined' && popupExtras.nonce) ? popupExtras.nonce : '';

            container.innerHTML = '';

            const messageBox = document.createElement('div');
            messageBox.id = 'extras-message';

            const form = document.createElement('form');
            form.id = 'modify-inscription-extras-form';

            const inputAction = document.createElement('input');
            inputAction.type  = 'hidden';
            inputAction.name  = 'action';
            inputAction.value = popupExtras.actionModifyExtras;

            const inputInscriptionID = document.createElement('input');
            inputInscriptionID.type  = 'hidden';
            inputInscriptionID.name  = 'inscription_id';
            inputInscriptionID.value = inscriptionID;

            const inputActivityID = document.createElement('input');
            inputActivityID.type  = 'hidden';
            inputActivityID.name  = 'activity_id';
            inputActivityID.value = activityID;

            const inputInscriptionType = document.createElement('input');
            inputInscriptionType.type  = 'hidden';
            inputInscriptionType.name  = 'inscription_type';
            inputInscriptionType.value = inscriptionType;

            const inputNonce = document.createElement('input');
            inputNonce.type  = 'hidden';
            inputNonce.name  = 'nonce';
            inputNonce.value = nonce;

            const fieldset = document.createElement('fieldset');

            // Monta el formulario y muéstralo antes del fetch
            messageBox.className = 'extras-message';
            messageBox.textContent = (popupExtras.text?.loadingExtras || 'Cargando extras...');

            form.appendChild(messageBox);
            form.appendChild(inputAction);
            form.appendChild(inputInscriptionID);
            form.appendChild(inputActivityID);
            form.appendChild(inputInscriptionType);
            form.appendChild(inputNonce);
            form.appendChild(fieldset);

            container.appendChild(form);

            // fuerza render para que se vea el texto
            await new Promise(requestAnimationFrame);

            const selectedExtras = new Set(parseExtrasString(extrasContratados));

            let availableExtras = [];
            try {
                availableExtras = await fetchAvailableExtras({
                    ajaxUrl,
                    activityID,
                    inscriptionType,
                    nonce,
                });
            } catch (err) {
                console.error('Error obteniendo extras disponibles:', err);
                availableExtras = [];
            }

            messageBox.textContent = '';
            fieldset.innerHTML = '';

            if (!availableExtras.length) {
                const p = document.createElement('p');
                p.textContent = (popupExtras.text?.noExtrasAvailable || 'No hay extras disponibles para esta inscripción.');
                fieldset.appendChild(p);
            } else {
                availableExtras.forEach((extra, index) => {
                    const wrapper = document.createElement('div');

                    const checkbox = document.createElement('input');
                    checkbox.type  = 'checkbox';
                    checkbox.name  = 'extras[]';
                    checkbox.value = extra;
                    checkbox.id    = `extra_${index}`;
                    checkbox.checked = selectedExtras.has(extra);

                    const label = document.createElement('label');
                    label.htmlFor = checkbox.id;
                    label.textContent = extra;

                    wrapper.appendChild(checkbox);
                    wrapper.appendChild(label);
                    fieldset.appendChild(wrapper);
                });
            }

            const submitBtn = document.createElement('button');
            submitBtn.classList.add('button', 'button-primary');
            submitBtn.type = 'submit';
            submitBtn.textContent = popupExtras.text.submit;

            form.appendChild(submitBtn);

            form.addEventListener('submit', async (ev) => {
                ev.preventDefault();

                messageBox.textContent = '';
                messageBox.className   = 'extras-message';

                const originalText = submitBtn.textContent;
                submitBtn.disabled = true;
                submitBtn.textContent = popupExtras.text.processing;

                const formData = new FormData(form);

                try {
                    const response = await fetch(ajaxUrl, { method: 'POST', body: formData });
                    const result = await response.json();
                    const success = result && (result.success === true || result.status === 'ok');

                    if (success) {
                        messageBox.textContent = result?.data?.message || popupExtras.text.ok;
                        messageBox.classList.add('extras-message--ok');

                        setTimeout(() => {
                            closePopup();
                            window.location.href = popupExtras.urlredirect;
                        }, 1000);
                    } else {
                        messageBox.textContent = result?.data?.message || popupExtras.text.error;
                        messageBox.classList.add('extras-message--error');

                        submitBtn.disabled = false;
                        submitBtn.textContent = originalText;
                    }
                } catch (error) {
                    console.error(popupExtras.text.consoleError, error);

                    messageBox.textContent = popupExtras.text.catcherror;
                    messageBox.classList.add('extras-message--error');

                    submitBtn.disabled = false;
                    submitBtn.textContent = originalText;
                }
            });
        });
    });

    closeBtn.addEventListener('click', closePopup);

    popup.addEventListener('click', (e) => {
        if (e.target === popup) {
            closePopup();
        }
    });
};
